
import { Component, Vue } from 'vue-property-decorator';
import { getTimeStatus } from '@/api/statistics';
import { Table } from 'element-ui';
@Component
export default class extends Vue {
  dates: (string | Date)[] = [];
  deviceTable = [];
  nodeTable: any[] = [];
  loading: boolean = false;
  total: number = 0;
  private pickerBeginDateBefore: { disabledDate: Function } = {
    disabledDate(time: any) {
      return time.getTime() > Date.now();
    },
  };
  statusParams: { page: number; page_size: number } = {
    page: 1,
    page_size: 10,
  };

  headRow({ row, column, rowIndex, columnIndex }: any) {
    if (columnIndex == 0 && rowIndex == 0) {
      return { 'border-bottom': 'none' };
    }
    return '';
  }
  tableRowClassName({ row, rowIndex }: { row: any; rowIndex: number }) {
    if (rowIndex === 0) {
      return 'bg-row';
    }
  }
  handleSizeChange(page: number) {
    this.statusParams.page = page;
    this.geDeviceStatus();
  }
  handleCurrentChange(page_size: number) {
    this.statusParams.page = 1;
    this.statusParams.page_size = page_size;
    this.geDeviceStatus();
  }
  getSummaries(param: any) {
    const { columns, data } = param;
    const sums: any[] = [];
    columns.forEach((column: any, index: number) => {
      if (index === 0) {
        sums[index] = '';
        return;
      }
      if (index === 1) {
        sums[index] = '合计';
        return;
      }
      const values = data.map((item: any) => Number(item[column.property.split('.')[0]][column.property.split('.')[1]]));
      if (!values.every((value: any) => isNaN(value))) {
        sums[index] = values.reduce((prev: any, curr: any) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
      }
    });

    return sums;
  }
  async geDeviceStatus() {
    this.loading = true;
    try {
      const res = await getTimeStatus(this.statusParams);
      if (res && res.code == 0) {
        this.deviceTable = res.data.devices;
        this.nodeTable = res.data.nodes;
      }
      this.loading = false;
    } catch (err) {
      //
      this.loading = false;
    }
  }
  mounted() {
    this.geDeviceStatus();
  }
}
